// CacheKey 623086058a02ccbebc0bd888cd9bdeb3
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-PAYER": {
    filters: {
      completed_on: {
        label: "Assessment Date",
        title: "filter by assessment date"
      },
      plan: {
        label: "Workflow",
        title: "Filter by workflow"
      },
      patient: {
        label: "Member",
        title: "Filter by member"
      },
      patient_tags: {
        label: "Member Tags",
        title: "Filter by member tags"
      },
      tags: {
        label: "Tags",
        title: "Filter by tags"
      }
    }
  }
}

